import {Flame, UtensilsCrossed, ChefHat, Wheat, Coffee, Wine, GlassWater, Sparkles} from 'lucide-react'
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'

function Gastronomia() {
  const acompanhamentos = [
    {
      nome: "Arroz Branco",
      descricao: "Base fundamental da refeição brasileira, o arroz soltinho acompanha perfeitamente a suculência das carnes.",
      imagem: "https://static.lumi.new/48/4894ea8f25a75db5eceab72557c0b9ac.png"
    },
    {
      nome: "Feijoada",
      descricao: "Prato típico brasileiro, a feijoada une feijão preto com diversos cortes de carne de porco, criando uma combinação rica e saborosa.",
      imagem: "https://static.lumi.new/61/61adbc23d395796184d7048331c43627.png"
    },
    {
      nome: "Couve à Mineira",
      descricao: "Refogada com alho e bacon, a couve é cortada em tirinhas bem fininhas e traz frescor e equilíbrio ao prato.",
      imagem: "https://static.lumi.new/1f/1f51a44dbcda28393e16235fed2896d6.png"
    },
    {
      nome: "Farofa",
      descricao: "Feita com farinha de mandioca torrada, a farofa pode ser enriquecida com bacon, ovos, linguiça e outros ingredientes.",
      imagem: "https://static.lumi.new/c8/c863fc0e6b57ef18db3544b1794931ba.png"
    }
  ]

  const cortes = [
    {
      nome: "Picanha",
      descricao: "A rainha do churrasco brasileiro, com sua capa de gordura que derrete durante o preparo.",
      imagem: "https://static.lumi.new/c2/c27f1ba9fa4c86499a21c14bd6527f1a.png"
    },
    {
      nome: "Costela",
      descricao: "Assada lentamente, a costela bovina fica macia e saborosa, derretendo na boca.",
      imagem: "https://static.lumi.new/6e/6e06ab5c42f140a0668c5f9709da2d77.png"
    },
    {
      nome: "Maminha",
      descricao: "Corte macio e suculento, perfeito para quem aprecia carnes mais macias.",
      imagem: "https://static.lumi.new/90/907870e9d3380a6b91514911541796bc.png"
    },
    {
      nome: "Fraldinha",
      descricao: "Corte versátil com fibras longas que proporcionam textura única.",
      imagem: "https://static.lumi.new/94/94f7c4753c83efd434a0ee6e5fb8b598.png"
    }
  ]

  const harmonizacoes = [
    {
      carne: "Picanha",
      vinho: "Malbec / Cabernet Sauvignon",
      descricao: "A gordura marcante da picanha pede tintos encorpados e taninos firmes que limpam o paladar a cada garfada."
    },
    {
      carne: "Costela",
      vinho: "Syrah / Tannat",
      descricao: "O sabor profundo e defumado da costela combina com tintos intensos, de notas especiadas e final longo."
    },
    {
      carne: "Maminha e Fraldinha",
      vinho: "Merlot / Pinot Noir",
      descricao: "Cortes mais delicados harmonizam com tintos de taninos macios e acidez equilibrada, sem encobrir a carne."
    },
    {
      carne: "Linguiça e Acompanhamentos",
      vinho: "Rosé seco / Tinto jovem",
      descricao: "Para entradas e guarnições, vinhos leves e refrescantes preparam o paladar para os cortes principais."
    }
  ]

  const cocktails = [
    {
      nome: "Caipirinha",
      descricao: "O coquetel mais icônico do Brasil: cachaça, limão, açúcar e gelo. Refrescante e cítrico, é o par perfeito para o churrasco.",
      ingredientes: "Cachaça · Limão · Açúcar · Gelo",
      imagem: "https://static.lumi.new/6c/6cc3d1b61c66779338e001627f074b19.png"
    },
    {
      nome: "Rabo de Galo",
      descricao: "Clássico paulistano que mistura cachaça com vermute tinto. Encorpado e levemente amargo, é um aperitivo sofisticado.",
      ingredientes: "Cachaça · Vermute tinto · Gelo",
      imagem: "https://static.lumi.new/32/32daef493b65768c6391dd6f9b4cc2f0.png"
    },
    {
      nome: "Batida",
      descricao: "Cremosa e tropical, a batida combina cachaça com frutas como coco, maracujá ou amendoim. Doce e marcante.",
      ingredientes: "Cachaça · Fruta · Leite condensado",
      imagem: "https://static.lumi.new/40/40aa3596ce971a957c2df3e1aa6a1d72.png"
    }
  ]

  const outrosCoquteis = [
    { nome: "Caipiroska", descricao: "Variação da caipirinha feita com vodka, mais suave e versátil." },
    { nome: "Caipifruta", descricao: "Caipirinha de frutas como morango, abacaxi ou kiwi, colorida e refrescante." },
    { nome: "Quentão", descricao: "Bebida quente de cachaça com gengibre, cravo e canela, típica das festas juninas." }
  ]

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1a1a1a] to-[#2d2d2d]">
      <Navbar />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#1a1a1a] via-[#2d2d2d] to-[#1a1a1a] py-20 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-96 h-96 bg-[#E53935] rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#C62828] rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center animate-fade-in">
            <div className="flex justify-center mb-6">
              <Flame className="text-[#E53935] w-20 h-20 animate-pulse" />
            </div>
            <h1 className="text-5xl md:text-7xl font-black text-white mb-6 leading-tight">
              A Gastronomia do
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#E53935] to-[#FF6F00] mt-2">
                Churrasco Brasileiro
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              Uma tradição que atravessa gerações, unindo sabores, técnicas e a arte de reunir pessoas ao redor do fogo
            </p>
          </div>
        </div>
      </section>

      {/* História do Churrasco */}
      <section className="py-20 bg-gradient-to-b from-[#2d2d2d] to-[#1a1a1a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6 animate-fade-in">
              <div className="flex items-center gap-3 mb-4">
                <ChefHat className="text-[#E53935] w-12 h-12" />
                <h2 className="text-4xl md:text-5xl font-black text-white">
                  História e Tradição
                </h2>
              </div>
              <p className="text-lg text-gray-300 leading-relaxed">
                O churrasco brasileiro tem suas raízes no sul do país, especialmente no Rio Grande do Sul, onde os gaúchos desenvolveram técnicas únicas de preparo da carne. A tradição nasceu com os tropeiros que percorriam longas distâncias e precisavam de alimentos que resistissem à jornada.
              </p>
              <p className="text-lg text-gray-300 leading-relaxed">
                Com o tempo, o churrasco se espalhou por todo o Brasil, incorporando influências regionais e se tornando parte fundamental da cultura brasileira. Cada região desenvolveu suas próprias variações, mas mantendo a essência: carnes de qualidade, fogo na medida certa e boa companhia.
              </p>
              <p className="text-lg text-gray-300 leading-relaxed">
                Hoje, o churrasco brasileiro é reconhecido mundialmente como uma das mais refinadas formas de preparo de carne, combinando técnica, tradição e paixão. É mais do que uma refeição – é um ritual que celebra a vida, a amizade e os sabores autênticos.
              </p>
            </div>

            <div className="relative">
              <div className="bg-gradient-to-br from-[#5D4037] to-[#3E2723] p-8 rounded-2xl shadow-2xl border-2 border-[#8D6E63]">
                <UtensilsCrossed className="text-[#E53935] w-16 h-16 mb-6" />
                <h3 className="text-2xl font-bold text-white mb-4">O Ritual do Churrasco</h3>
                <ul className="space-y-4 text-gray-200">
                  <li className="flex items-start gap-3">
                    <Flame className="text-[#FF6F00] w-6 h-6 flex-shrink-0 mt-1" />
                    <span>Preparação do fogo com lenha ou carvão de qualidade</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Flame className="text-[#FF6F00] w-6 h-6 flex-shrink-0 mt-1" />
                    <span>Seleção dos melhores cortes de carne bovina</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Flame className="text-[#FF6F00] w-6 h-6 flex-shrink-0 mt-1" />
                    <span>Tempero simples: sal grosso realça o sabor natural</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Flame className="text-[#FF6F00] w-6 h-6 flex-shrink-0 mt-1" />
                    <span>Tempo e paciência para o ponto perfeito</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cortes Tradicionais */}
      <section className="py-20 bg-gradient-to-b from-[#1a1a1a] to-[#2d2d2d]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
              Cortes Tradicionais
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              Os cortes clássicos que fazem do churrasco brasileiro uma experiência única
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {cortes.map((corte, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-[#5D4037] to-[#4E342E] rounded-xl border-2 border-[#8D6E63] hover:border-[#E53935] transition-all duration-300 hover:shadow-xl hover:shadow-[#E53935]/20 hover:scale-105 overflow-hidden"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={corte.imagem}
                    alt={corte.nome}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#4E342E] via-transparent to-transparent"></div>
                  <div className="absolute top-3 left-3 w-10 h-10 bg-[#E53935] rounded-full flex items-center justify-center shadow-lg">
                    <Flame className="text-white w-5 h-5" />
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-white mb-3">{corte.nome}</h3>
                  <p className="text-gray-300 leading-relaxed text-sm">{corte.descricao}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Acompanhamentos */}
      <section className="py-20 bg-gradient-to-b from-[#2d2d2d] to-[#1a1a1a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex justify-center mb-4">
              <Coffee className="text-[#E53935] w-16 h-16" />
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
              Acompanhamentos Essenciais
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              Os complementos perfeitos que transformam o churrasco em uma experiência completa
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {acompanhamentos.map((acomp, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-[#3E2723] to-[#2d2d2d] rounded-2xl border-2 border-[#5D4037] hover:border-[#E53935] transition-all duration-300 hover:shadow-2xl hover:shadow-[#E53935]/30 overflow-hidden"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={acomp.imagem}
                    alt={acomp.nome}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2d2d2d] via-transparent to-transparent"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-[#E53935] transition-colors">
                    {acomp.nome}
                  </h3>
                  <p className="text-gray-300 leading-relaxed text-sm">
                    {acomp.descricao}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-gradient-to-br from-[#5D4037] to-[#4E342E] p-10 rounded-2xl border-2 border-[#8D6E63] shadow-2xl">
            <div className="flex items-start gap-6">
              <Wheat className="text-[#FF6F00] w-12 h-12 flex-shrink-0" />
              <div>
                <h3 className="text-3xl font-bold text-white mb-4">
                  A Harmonia Perfeita
                </h3>
                <p className="text-lg text-gray-200 leading-relaxed mb-4">
                  A combinação entre carnes suculentas e acompanhamentos tradicionais cria uma experiência gastronômica única. Cada elemento complementa o outro, trazendo equilíbrio de sabores, texturas e temperaturas.
                </p>
                <p className="text-lg text-gray-200 leading-relaxed">
                  O arroz absorve os sucos das carnes, a farofa adiciona crocância, a couve traz frescor, e a feijoada oferece profundidade de sabor. Juntos, formam o que conhecemos como o verdadeiro churrasco brasileiro – uma celebração da nossa cultura e tradição culinária.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Harmonização com Vinhos */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://static.lumi.new/c9/c92df8f71e5950334eccb7a1e50577d6.png"
            alt="Harmonização com vinhos"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#1a1a1a]/85"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <div className="flex justify-center mb-4">
              <Wine className="text-[#E53935] w-16 h-16" />
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
              Harmonização com Vinhos
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              A escolha do vinho certo eleva cada corte a uma nova dimensão de sabor
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {harmonizacoes.map((item, index) => (
              <div
                key={index}
                className="group bg-[#2d2d2d]/80 backdrop-blur-sm p-6 rounded-2xl border-2 border-[#5D4037] hover:border-[#E53935] transition-all duration-300 hover:shadow-xl hover:shadow-[#E53935]/20"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#E53935] to-[#C62828] rounded-full flex items-center justify-center flex-shrink-0">
                    <Wine className="text-white w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white">{item.carne}</h3>
                    <p className="text-[#FF6F00] font-semibold text-sm">{item.vinho}</p>
                  </div>
                </div>
                <p className="text-gray-300 leading-relaxed text-sm">{item.descricao}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cocktails Clássicos Brasileiros */}
      <section className="py-20 bg-gradient-to-b from-[#1a1a1a] to-[#2d2d2d]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="flex justify-center mb-4">
              <GlassWater className="text-[#E53935] w-16 h-16" />
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-white mb-4">
              Cocktails Clássicos Brasileiros
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              A cachaça é a alma dos drinks brasileiros, presentes em todo bom encontro ao redor da churrasqueira
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {cocktails.map((drink, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-[#3E2723] to-[#2d2d2d] rounded-2xl border-2 border-[#5D4037] hover:border-[#E53935] transition-all duration-300 hover:shadow-2xl hover:shadow-[#E53935]/30 overflow-hidden hover:-translate-y-2"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={drink.imagem}
                    alt={drink.nome}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2d2d2d] via-transparent to-transparent"></div>
                  <div className="absolute top-3 right-3 w-10 h-10 bg-[#E53935] rounded-full flex items-center justify-center shadow-lg">
                    <Sparkles className="text-white w-5 h-5" />
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-[#E53935] transition-colors">
                    {drink.nome}
                  </h3>
                  <p className="text-[#FF6F00] text-xs font-semibold mb-3 uppercase tracking-wide">
                    {drink.ingredientes}
                  </p>
                  <p className="text-gray-300 leading-relaxed text-sm">
                    {drink.descricao}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Outros coquetéis */}
          <div className="mt-12 grid md:grid-cols-3 gap-6">
            {outrosCoquteis.map((item, index) => (
              <div
                key={index}
                className="flex items-start gap-4 bg-[#5D4037]/40 p-5 rounded-xl border border-[#5D4037] hover:border-[#E53935] transition-all duration-300"
              >
                <GlassWater className="text-[#FF6F00] w-7 h-7 flex-shrink-0 mt-1" />
                <div>
                  <h4 className="text-lg font-bold text-white mb-1">{item.nome}</h4>
                  <p className="text-gray-300 text-sm leading-relaxed">{item.descricao}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-gradient-to-br from-[#5D4037] to-[#4E342E] p-10 rounded-2xl border-2 border-[#8D6E63] shadow-2xl">
            <div className="flex items-start gap-6">
              <Sparkles className="text-[#FF6F00] w-12 h-12 flex-shrink-0" />
              <div>
                <h3 className="text-3xl font-bold text-white mb-4">
                  Brinde à Brasileira
                </h3>
                <p className="text-lg text-gray-200 leading-relaxed">
                  Nenhum churrasco brasileiro está completo sem uma bela rodada de drinks. A caipirinha gelada corta a gordura das carnes, o rabo de galo aquece a conversa e as batidas adoçam o encontro. São bebidas que carregam a alegria, a hospitalidade e o calor do nosso povo – o complemento perfeito para celebrar a gastronomia brasileira em qualquer canto do mundo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default Gastronomia
